import _ from 'lodash';
export const buildCategoriesBulkUpdatePayload = (altTextData, categoriesMap) => {
  const collections = [];
  altTextData.forEach(altTextItem => {
    var _updatedCategory$medi;
    const {
      entityId,
      id,
      alt
    } = altTextItem;
    if (!entityId) {
      return;
    }
    const category = categoriesMap.get(entityId);
    if (!category) {
      return;
    }
    const updatedCategory = _.cloneDeep(category);
    if ((_updatedCategory$medi = updatedCategory.media) != null && _updatedCategory$medi.items) {
      updatedCategory.media.items.forEach(mediaItem => {
        if (mediaItem.id === id && mediaItem.image) {
          mediaItem.image.altText = alt;
        }
      });
    }
    collections.push({
      collection: updatedCategory
    });
  });
  return {
    collections
  };
};
//# sourceMappingURL=bulk-update-categories-alt-text-payload-builder.js.map